import LocalizedLink from "@commons/infra/i18n/LocalizedLink";
import React from "react";

export let CtaLink = ({text, link}) => {
    return <div className="pb-2 pt-lg-2 text-center" style={{zIndex: 3}}>
        <LocalizedLink to={link} className={"fs-lg fw-500"}>
            {text}

            <i className={"ai ai-arrow-right ms-1"}/>
        </LocalizedLink>
    </div>
}